import React, { useEffect, useState } from 'react';
import { translate } from '../Services/translation';
import { receive } from '../Actions/Cart.action';
import { useSelector, useDispatch } from 'react-redux';

const closeMiniCart = () => {
  const elements = document.querySelectorAll('.cart__info, .cart__background--overlay');
  for (const element of elements) {
    element.classList.add('cart__info--hidden');
  }
};
const getOrderCount = (orderRows) => {
  return orderRows.length;
};
const MiniCart = ({ salesQuotationId, quantity, orderTotal, checkoutUrl, showInfo, addedProduct, orderRows, }) => {
  if (addedProduct) {
    for (const orderRow of orderRows) {
      if (orderRow.articleNumber === addedProduct) {
        addedProduct = orderRow;
      }
    }
  }

  // Close cart after 5 seconds
  setTimeout(closeMiniCart, 8000);

  return (
    <div className='cart cart--mini'>
      <div className='cart--icon'>
        <a className='cart__link--block' href={checkoutUrl}>
          {getOrderCount(orderRows) <= 0 ? (
            <>
              <svg>
                <use href='/ui/images/sprites/be-group.svg#cart'></use>
              </svg>
            </>
          ) : (
            <>
              <span
                className='cart--count'
                title={'SalesQuotationId: ' + salesQuotationId}
              >
                {getOrderCount(orderRows)}
              </span>
              <svg>
                <use href='/ui/images/sprites/be-group.svg#cart-fill'></use>
              </svg>
            </>
          )}
        </a>
      </div>

      <div className='cart__background--overlay cart__info--hidden'>
        <div className='cart__info--container'>
          <div className='cart__info--inner_container'>
            <div className='cart__info--arrow_up'></div>
          </div>
          <div
            className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}
          >
            <span
              className='cart__close-button'
              onClick={() => closeMiniCart()}
            >
              <svg>
                <use href='/ui/images/sprites/be-group.svg#cross'></use>
              </svg>
            </span>

            {addedProduct === undefined ? (
              <>
                <p className='cart__info-row'>
                  {quantity} {translate('minicart.numberofproduct')}
                </p>
                <p className='cart__info-row'>
                  <b>{translate('minicart.total')}</b> {orderTotal}
                </p>
                <a href={checkoutUrl} className='cart__checkout-button'>
                  {translate('minicart.checkout')}
                </a>
              </>
            ) : (
              <>
                <p className='cart__info-row cart__thumbsup-container'>
                  <svg>
                    <use href='/ui/images/sprites/be-group.svg#thumbsup'></use>
                  </svg>
                </p>
                <p className='cart__info-row cart__notice-title'>
                  {translate('minicart.productsuccessmessage')}
                </p>
                <div className='cart__added-product-name'>
                  <img src={addedProduct.image}></img>
                  <p className='cart__info-row '>{addedProduct.name}</p>
                </div>
              </>
            )}

            <div className='cart__checkout-buttons'>
              <a
                href='#'
                onClick={() => closeMiniCart()}
                className='cart__checkout-button button button--transparent'
              >
                {translate('minicart.continue')}
              </a>
              <a
                href={checkoutUrl}
                className='cart__checkout-button button button--orange'
              >
                {translate('minicart.checkout')}
              </a>
            </div>
          </div>
        </div>

        <div className='cart__background' onClick={() => closeMiniCart()}></div>
      </div>
    </div>
  );
};

export default MiniCart;
